import React, { useEffect, useState } from 'react'
import { ClearFilterButton, CreateButton, ExportButton, FilterButton, ImportButton } from '../../../Components/Utils/Buttons'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import SearchBar from '../../../Components/Utils/SearchBar'
import { GetAccess } from '../../../Components/Utils/roles'
import List from '../../../Components/Icons/list'
import Card from '../../../Components/Icons/card'
import Breadcrumb from '../../../Components/Utils/Breadcrumb'


const QuotationLayout = (
  {
    getData=() => {},
    setSearchQuery=()=>{},
    CreateAccess= false,
    ImportAccess= false,
    setOpen=()=>{},
    setOpenExport=()=>{},
    children,
    onCreateClick,
    searchValue="",
    searchFun=()=>{},
    isFilter=false,
    setFilterOpen=()=>{},
    newfilter=false,
    ClearFilter=()=>{},
    neededSearch=false,
    showproject=true,
    isCard=true,
    setViewMode=()=>{},
        viewMode="",
        ExportAccess=false,
        total={total}

}
) => {

  let {pathname} = useLocation()
  const [module,setModule] = useState("")
  const navigate = useNavigate();
         
    
    
    let searchList = [
        { value: "all", label: "All" },
        { value: "services", label: "Services" },
        { value: "products", label: "Products" },
      ];

        const [screenSize, setScreenSize] = useState({
          width: window.innerWidth,
        });
      
        useEffect(() => {
          const handleResize = () => {
            setScreenSize({
              width: window.innerWidth,
            });
          };
      
          window.addEventListener("resize", handleResize);
      
          return () => {
            window.removeEventListener("resize", handleResize);
          };
        }, []);
  
  useEffect(() =>{
      if(pathname == `/quotation/quote`){
          setModule("Quotation")

      }
    //   else if(pathname == `/client-management/survey-report`){
    //       setModule("Survey")
    //   }else if(pathname == `/client-management/equiments`){
    //     setModule("Cont. Equipt.")
    // }else if(pathname == `/client-management/contracts`){
    //       setModule("Contract")
    //   }
  },[pathname])

  let LinkItem = [
      {
          label:"Quotation",
          link:`/quotation/quote`,
          access:GetAccess("quotes_view"),
          
      },
      // {

      //     label:"Surveys",

      //     link:`/client-management/survey-report`,
      //     access:GetAccess("survey_view"),
      // },
      // {
      //   label:"Cont. Equipments",           
      //     link:`/client-management/equiments`,
      //     access:GetAccess(),
      // },
      // {
      //   label:"Contracts",           
      //     link:`/client-management/contracts`,
      //     access:GetAccess("contracts_view"),
      // },
     
     
  ];

  const handleCreateClick = () => {
    if (module === "Cont. Equipt.") {
        onCreateClick && onCreateClick(); 
    } else {
      navigate(`${pathname}/create`);
    }
  };



  return(
    <div className=" w-full  h-full py-2 px-4 overflow-hidden">
            
            <div className="md:flex justify-between w-full ">
           
            <Breadcrumb
                  items={[
                    // { name: "Quotation" },
                   
        
                    { name: module },
                  ]}
                />
                 <div className=" flex justify-end items-center gap-3 ">
           
           <form className="flex items-center gap-3 mx-0" onSubmit={getData}>
          
          {neededSearch &&  <SearchBar handleChange={searchFun}  value={searchValue}/>}

           </form>
           {/* {
               screenSize.width >= "1024" &&(<>
               
               {isCard &&

<div className='flex gap-2'>
<div onClick={() => setViewMode("list")} className={viewMode === "list" ? "bg-baseColor-primary h-8 w-10 rounded-md flex justify-center items-center text-white" : "bg-white h-8 w-10 rounded-md flex justify-center items-center cursor-pointer"}><List/></div>
<div onClick={() => setViewMode("card")} className={viewMode === "card" ? "bg-baseColor-primary h-8 w-10 rounded-md flex justify-center items-center text-white" : "bg-white h-8 w-10 rounded-md flex justify-center items-center cursor-pointer"}><Card/></div>
</div>
}
               </>)
             } */}
           {newfilter && (
 <>
             <FilterButton label='Filter'  handleClick={()=>{setFilterOpen(true);setSearchQuery("");}} />
             {isFilter&& <ClearFilterButton label='Clear'  handleClick={ClearFilter} />} </>)}
              {ImportAccess && <ImportButton label="Import" handleClick={()=>setOpen(true)}    />}
              {ExportAccess && <ExportButton label="Export" handleClick={()=>setOpenExport(true)}    />}

             {CreateAccess &&  <CreateButton
                         handleClick={handleCreateClick}
                         label="Add"
                         className="create-activity-button"
                       />}
                     </div>
            </div>

      <div className="w-full overflow-x-auto whitespace-nowrap scrollbar-hide md:flex  gap-x-10 mt-0.5">
        <div className="inline-flex items-center gap-x-1">
      {LinkItem &&
    LinkItem.map((item, i) => {
      const isActive = item?.link === pathname;
      return (
        item.access && (
          <Link
            to={item?.link}
            key={item?.link}
            className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-0.5
              ${isActive 
                ? "bg-baseColor-primary text-white" 
                : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
              }`}
          >
            {item?.label || ""}
          </Link>
        )
      );
    })}
</div>
           
     <div className="sm:mt-0 mt-1 h-auto border rounded-full mr-3 md:ml-0 ml-4 border-baseColor-primary text-xs inline-flex w-auto flex-shrink-0 justify-center overflow-hidden">
  <p className="w-auto bg-white text-black px-2 flex items-center justify-center">
    Total
  </p>
  <p className="bg-baseColor-primary w-auto text-white px-2 flex items-center justify-center">
    {total || "0"}
  </p>
</div>


    </div>
         
    
          
           
            <div className=" w-full h-[calc(100vh-211px)] md:h-[calc(100vh-165px)]  ">
               {children} 
            </div>
            </div>
       
)
    }
export default QuotationLayout